




























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class InputTextArea extends Vue {
    @Prop({ required: true })
    private value!: string | null;

    @Prop({ type: String, required: false, default: '' })
    private label!: string;

    @Prop({ type: String, required: true })
    private name!: string;

    @Prop({ type: [String, Object], required: false, default: '' })
    private rules!: string | object;

    @Prop({ type: Boolean, required: false, default: false })
    private autofocus!: boolean;

    @Prop({ type: Boolean, required: false, default: true })
    private showErrors!: boolean;

    @Prop({ type: Boolean, required: false, default: false })
    private required!: boolean;

    @Prop({ type: Number, required: false, default: 5 })
    private rows!: number;

    private get id() {
        return this.name + Math.random();
    }

    private get listeners() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { input, ...listeners } = this.$listeners;
        return listeners;
    }

    private get hasValue(): boolean {
        return this.value !== '' && this.value != null;
    }

    private get labelText(): string {
        return this.required ? `${this.label}*` : this.label;
    }

    private changedInput(event) {
        this.$emit('input', event.target.value);
    }
}
